import { render, staticRenderFns } from "./CountryItem.vue?vue&type=template&id=b6dffada&scoped=true&"
import script from "./CountryItem.vue?vue&type=script&lang=js&"
export * from "./CountryItem.vue?vue&type=script&lang=js&"
import style0 from "./CountryItem.vue?vue&type=style&index=0&id=b6dffada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dffada",
  null
  
)

export default component.exports